import { Routes } from '@angular/router';

import { logoutGuard } from './guards/logout.guard';
import { Error500Page } from './pages/error/500/error-500.page';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'appointment',
  },
  {
    path: 'appointment',
    loadChildren: (): Promise<Routes> =>
      import('./pages/appointment/appointment.routes').then((m): Routes => m.APPOINTMENT_ROUTES),
  },
  {
    path: 'error-500',
    loadComponent: (): Promise<typeof Error500Page> =>
      import('./pages/error/500/error-500.page').then((m): typeof Error500Page => m.Error500Page),
  },
  {
    path: 'logout',
    canActivate: [logoutGuard],
    children: [],
  },
  {
    path: '**',
    redirectTo: 'appointment',
  },
];
